export const getTimeStamp = (totalSeconds: number) => {
  const minutes = Math.floor(totalSeconds / 60)
  let seconds = (totalSeconds % 60).toFixed(0)
  if (+seconds < 10) {
    seconds = `0${seconds}`
  }
  return `${minutes}:${seconds}`
}
